// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Title-wrap-6yyxk","svg":"Title-svg-16AIl","letters":"Title-letters-tZmFK"};